import React, { Component } from "react";

const style = {
  list: { listStyleType: "none", width: "50%", marginLeft: "25%" },
  header: { backgroundColor: "lightgray", padding: "5px" },
  author: {
    fontSize: ".8rem",
    fontStyle: "italic"
  },
  date: {
    fontSize: ".8rem",
    fontStyle: "italic",
    float: "left"
  },
  action: {
    fontSize: ".8rem",
    float: "right",
    color: "blue",
    textDecoration: "underline"
  },
  comment: {
    fontSize: "1rem",
    textAlign: "justify",
    wordWrap: "break-word",
    marginBottom: "2rem"
  },
  moderate: {
    fontSize: ".8rem",
    float: "right",
    color: "red",
    textDecoration: "underline",
    marginLeft: "1rem",
    marginRight: "1rem"
  }
};

export default class Comment extends Component {
  render() {
    const {
      pitchOwner,
      evalId,
      videoId,
      impressions,
      userName,
      userMail,
      createdAt,
      i
    } = this.props;

    const moderateMail = `
        mailto:${process.env.REACT_APP_SPEEKER_EMAIL}?subject=Commentaire inaproprié
        &body=Merci de bien vouloir vérifier une évaluation sur mon pitch. 
        %0D%0A
        %0D%0ARéférence vidéo:  ${videoId}
        %0D%0A
        %0D%0ARéférence Evaluation:  ${evalId}
        %0D%0A
        %0D%0ACordialement, ${pitchOwner.displayName}.
      `;

    return (
      <li key={i} style={style.list}>
        <p style={style.header}>
          <span style={style.date}>{createdAt}</span>
          <span style={style.author}>{userName}</span>

          <a
            href={`mailto:${userMail}?subject=Votre commentaire sur mon pitch.`}
            style={style.action}
            target="_blank"
            rel="noopener noreferrer"
          >
            Contacter
          </a>
          <a href={moderateMail} style={style.moderate} target="_blank" rel="noopener noreferrer">
            Signaler
          </a>
        </p>
        <p style={style.comment}>
          {
            impressions
          }
        </p>
      </li>
    );
  }
}
